import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { EquipmentTypes } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (equipmentType: M extends true ? EquipmentTypes[] : EquipmentTypes) => void
} & TomAutoCompleteProps<EquipmentTypes, M>

export const EquipmentTypeAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange } = props

  const [options] = useState<EquipmentTypes[]>(
    Object.values(EquipmentTypes).filter(c => c !== EquipmentTypes.None),
  )

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'equipment-type-autocomplete'}
      label={label ?? t('equipmentType', 'Equipment Type')}
      options={options}
      defaultValue={defaultValue}
      enablePortal
      placeholder={t('selectEquipmentType', 'Select equipment type')}
      onChangeEntity={entity => {
        onChange(entity as M extends true ? EquipmentTypes[] : EquipmentTypes)
      }}
    />
  )
})
